// extracted by mini-css-extract-plugin
export default {"privacyContainer":"terms_privacyContainer__Lj8Wm","imgContainer":"terms_imgContainer__g+UPj","terms_button":"terms_terms_button__zvS+r","terms_content":"terms_terms_content__dplnj"};